import { render, staticRenderFns } from "./UpdateMatch.vue?vue&type=template&id=28343a5f&"
import script from "./UpdateMatch.vue?vue&type=script&lang=js&"
export * from "./UpdateMatch.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports